import colors from 'vuetify/lib/util/colors'

const green = {
  primary: '#1976D2',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
}

const light = {
  primary: colors.teal.darken1,
  accent: colors.indigo.darken1,
  info: colors.blue,
  error: colors.pink.darken2,
  success: colors.teal.lighten1,
  warning: colors.purple.darken1,
}

const blue = {
  primary: colors.blue.darken4,
  accent: colors.blue.darken1,
  info: colors.blue,
  error: colors.pink.darken2,
  success: colors.blue.lighten1,
  warning: colors.purple.darken1,
}


export default {
  light,
  green,
  blue
}


// WEBPACK FOOTER //
// ./src/plugins/theme.js